import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initAnalytics, trackPageview, isAnalyticsEnabled } from './lib/analytics';
import ConsentBanner, { getStoredConsent } from './components/ConsentBanner';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// 同意後にのみ解析初期化とページビュー送信
const consent = getStoredConsent();
if (consent === 'granted') {
  initAnalytics();
  if (isAnalyticsEnabled()) {
    trackPageview(window.location.pathname + window.location.search);
  }
}
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <ConsentBanner onChange={(status) => {
        if (status === 'granted') {
          initAnalytics();
          if (isAnalyticsEnabled()) {
            trackPageview(window.location.pathname + window.location.search);
          }
        }
      }} />
    </BrowserRouter>
  </React.StrictMode>
); 